export const checkLeaveLimit = (requests: any, leaveType: any, newRequestNoOfDays: any, newRequestTotalHour: any, month: string, dataCheckBy: string, employmentType: string) => {
    let totalLeaveDays = 0;
    let employmentTypeHour = 0;
    employmentTypeHour = employmentType === "Full Time" ? 8 : 4;
    const newRequestValue = newRequestNoOfDays !== "0" ? newRequestNoOfDays : formatTotalHours(newRequestTotalHour, employmentTypeHour);

    for (const dateKey in requests) {
        const dateRequests = requests[dateKey];
        for (const requestId in dateRequests) {
            const request = dateRequests[requestId];
            if (dataCheckBy === "year" && request.status !== "Rejected") {
                if (request.leaveType === leaveType) {
                    totalLeaveDays += parseFloat(request.noOfDays);
                }
            }
            if (dataCheckBy === "month") {
                if (request.leaveType === leaveType && request.status !== "Rejected") {
                    const requestMonth = new Date(request.startDate).toISOString().slice(0, 7);
                    if (requestMonth === month) {
                        const requestValue = request.noOfDays !== "0" ? request.noOfDays : formatTotalHours(request.totalhours, employmentTypeHour);
                        totalLeaveDays += parseFloat(requestValue);
                    }
                }
            }
        }
    }
    console.log(totalLeaveDays + parseFloat(newRequestValue));


    return totalLeaveDays + parseFloat(newRequestValue);
};


export const formatTotalHours = (value: string, employmentTypeHour: number) => {
    let formatedValue = Number(value) / employmentTypeHour;
    return formatedValue
}

export const formatDaysAndHours = (value: any, employmentType: any) => {
    let employmentTypeHour = 0;
    employmentTypeHour = employmentType === "Full Time" ? 8 : 4;
    const totalHours = value * employmentTypeHour;
    const days = Math.floor(totalHours / employmentTypeHour);
    const hours = Math.round(totalHours % employmentTypeHour);

    const formattedDays = days < 10 ? `${days}` : days;
    const formattedHours = hours < 10 ? `${hours}` : hours;

    return `${formattedDays} days ${formattedHours} hours `;
};